import { createApp } from 'vue'

import App from './App'
import store from './store'

const setupApp = () => {
    const rootElement = document.querySelector( '#wbk-projects-app' )
    const appInstance = createApp( App )

    appInstance.use( store )
    appInstance.mount( rootElement )
}

document.addEventListener( 'DOMContentLoaded', setupApp )